import { FrequencyOfPayment } from '../graphql/generated';

export const salaryFrequencyMap: Record<FrequencyOfPayment, string> = {
  WEEKLY: 'Weekly',
  BI_WEEKLY: 'Bi Weekly',
  SEMI_MONTHLY: 'Semi Monthly',
  MONTHLY: 'Monthly ',
  OTHER: 'Other',
};
